import { SelectionProps } from "@/interfaces/SelectionProps";
import { FC } from "react";
import RangeSlider from "@/components/RangeSlider";
import SearchScafold from "@/components/SearchScafold";
import { FloorSpaceFormField } from "@/consts/RangeSlider";
import useRangeSlider from "@/hooks/useRangeSlider";
import {
  FloorSpaceMax,
  FloorSpaceMin,
  FloorSpaceShortcuts,
  FloorSpaceStep,
  FloorSpaceUnit,
} from "@/consts/FloorSpace";

const FloorScaleSelection: FC<SelectionProps<FloorSpaceFormField>> = ({
  defaultValue,
  onUpdate,
  onBack,
}): JSX.Element => {
  const rangeSlider = useRangeSlider({
    defaultMin: defaultValue.min_floor_space,
    defaultMax: defaultValue.max_floor_space,
    min: FloorSpaceMin,
    max: FloorSpaceMax,
  });

  return (
    <SearchScafold
      title={"面積"}
      handleSubmit={() => {
        onUpdate({
          min_floor_space: rangeSlider.minQueryValue,
          max_floor_space: rangeSlider.maxQueryValue,
        });
        onBack();
      }}
    >
      <div className="p-20 flex flex-col flex-start space-y-12">
        {FloorSpaceShortcuts.map((shortcut) => {
          return (
            <button
              key={shortcut.label}
              className="text-left text-sm"
              type="button"
              onClick={() => {
                rangeSlider.updateMax(
                  String(shortcut.max ? shortcut.max : FloorSpaceMax),
                  true,
                );
                rangeSlider.updateMin(
                  String(shortcut.min ? shortcut.min : FloorSpaceMin),
                  true,
                );
              }}
            >
              {shortcut.label}
            </button>
          );
        })}

        <RangeSlider
          rangeSlider={rangeSlider}
          step={FloorSpaceStep}
          unit={FloorSpaceUnit}
        />
      </div>
    </SearchScafold>
  );
};
export default FloorScaleSelection;
